import { RouteObject } from 'react-router-dom';
import { lazy, Suspense } from 'react';

const ContactUsComponent = lazy(() => import('./contact-us.tsx'));

export const contactUsRoutes: RouteObject[] = [
  {
    path: '',
    element: (
      <Suspense>
        <ContactUsComponent />
      </Suspense>
    )
  }
];
